import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber7 = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm2.953 5.12-2.755 6.782H6.667l2.755-6.651H6.608v1.258H5.337V4.038h5.616V5.12z" />
    </g>
  );
};

export default withIcon(IconNumber7);
